import styled from "@emotion/styled";
import { Button } from "bonde-components/chakra";

const ButtonStyled = styled(Button)`
  width: auto;
  min-width: 140px;
  margin-right: 15px;
`;

export default ButtonStyled;